
import { WDFormInput } from './wd-form-input';

export class WDFormDatetimelocal extends WDFormInput {

  constructor(cfg) {
    cfg.type = 'datetime-local';
    super(cfg);
  };

  set value(val)
  {  
      const format = (this.getAttribute('type') == 'date') ? 'Y-m-d' : 'Y-m-dTH:i:s';

      //if not passed a T, we were just passed a straight upd ate which would be interpretted as UTC
      const date = val.includes('T') ? new Date(val) : new Date(val).localDate();
      const formatted = date.format(format);
      
      super.value = formatted;
  };
};

customElements.define('wd-form-datetime-local',WDFormDatetimelocal);

